// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"a974ad11","345":"a4619415","525":"4d58e1d0","647":"d9fdfe37","727":"4d58e1d0","995":"7028b055"}[chunkId] + ".chunk.css";
};